import { SvgStaticImage } from "@gromia/components/SvgStaticImage";
import * as s from "@gromia/components/theme/t.module.css";
import { useMedia } from "@gromia/utils/useMedia";
import cx from "classnames";
import React from "react";
import * as spriv from "./ComparisonTable.module.css";

type ItemProps = {
  labl: NonNullable<React.ReactNode>;
  lval: NonNullable<React.ReactNode>;
  rval: NonNullable<React.ReactNode>;
  index?: number;
  last?: boolean;
};

function Item(props: ItemProps) {
  return (
    <React.Fragment>
      <div className={cx(spriv.cell, spriv.cell1)} />
      <div
        className={cx(
          spriv.cell,
          spriv.cell2,
          s.fontWeightBold,
          s.fontSizeLgLarge1,
          s.fontSizeMdBase,
          s.fontSizeSmSmall1,
          s.fontSizeSmall2,
        )}
      >
        {props.labl}
      </div>
      <div
        className={cx(
          spriv.cell,
          spriv.cell3,
          s.fontWeightSemiBold,
          s.fontSizeLgLarge1,
          s.fontSizeMdBase,
          s.fontSizeSmSmall1,
          s.fontSizeSmall2,
        )}
      >
        {props.lval}
      </div>
      <div
        className={cx(
          spriv.cell,
          spriv.cell4,
          s.fontWeightSemiBold,
          s.fontSizeLgLarge1,
          s.fontSizeMdBase,
          s.fontSizeSmSmall1,
          s.fontSizeSmall2,
        )}
      >
        {props.rval}
      </div>
      <div className={cx(spriv.cell, spriv.cell5)} />
      {props.last ? null : (
        <React.Fragment>
          <div className={cx(spriv.cgutter)} />
          <div className={cx(spriv.cgutter)} />
          <div className={cx(spriv.cgutter)} />
          <div className={cx(spriv.cgutter, spriv.cgutter4)} />
          <div className={cx(spriv.cgutter, spriv.cgutter5)} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

function Header(props: Pick<ItemProps, "rval" | "lval">) {
  return (
    <React.Fragment>
      <div className={cx(spriv.header, spriv.header1)} />
      <div className={cx(spriv.header, spriv.header2)} />
      <div
        className={cx(
          spriv.header,
          spriv.header3,
          s.fontWeightSemiBold,
          s.fontSizeLgLarge1,
        )}
      >
        {props.lval}
      </div>
      <div
        className={cx(
          spriv.header,
          spriv.header4,
          s.fontWeightSemiBold,
          s.fontSizeLgLarge1,
        )}
      >
        {props.rval}
      </div>
      <div className={cx(spriv.header, spriv.header5)} />
      <div className={cx(spriv.hgutter, spriv.hgutter1)} />
      <div className={cx(spriv.hgutter, spriv.hgutter2)} />
      <div className={cx(spriv.hgutter, spriv.hgutter3)} />
      <div className={cx(spriv.hgutter, spriv.hgutter4)} />
      <div className={cx(spriv.hgutter, spriv.hgutter5)} />
    </React.Fragment>
  );
}

function Footer() {
  return (
    <React.Fragment>
      <div className={cx(spriv.fgutter, spriv.fgutter1)} />
      <div className={cx(spriv.fgutter, spriv.fgutter2)} />
      <div className={cx(spriv.fgutter, spriv.fgutter3)} />
      <div className={cx(spriv.fgutter, spriv.fgutter4)} />
      <div className={cx(spriv.fgutter, spriv.fgutter5)} />
    </React.Fragment>
  );
}

type Props = {
  children: Array<React.ReactElement<ItemProps>>;
};

export function ComparisonTable(props: Props) {
  const media = useMedia();
  const nchildren = React.Children.count(props.children);
  return (
    <div className={cx(spriv.table)}>
      <Header
        lval={media.sm ? "Agenzie immobiliari" : "Agenzie"}
        rval={media.sm
          ? (
            "Gromia"
          )
          : (
            <SvgStaticImage
              width={24}
              height={24}
              src={require("./ComparisonTable2/logo-pin.svg")}
              alt="Gromia"
            />
          )}
      />
      {React.Children.map(props.children, (c, index) =>
        React.cloneElement(c, {
          index,
          last: index === nchildren - 1,
        }))}
      <Footer />
    </div>
  );
}

ComparisonTable.Item = Item;
